import { useState } from 'react';
import { Icon } from '../components/Icon.jsx';
import { AlertBanner } from '../components/AlertBanner.jsx';
import { mockSave } from '../services/botConfigService.js';

export function NameGreetingPanel({ bot, updateBot, mockErrorOn, notify }) {
  const [draft, setDraft] = useState({ name: bot.name, greeting: bot.greeting });
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState('idle'); // idle | saving | error
  const isEmpty = !bot.name && !bot.greeting;

  function validate(d) {
    const e = {};
    if (!d.name || d.name.trim().length < 3) e.name = 'Bot name must be at least 3 characters.';
    else if (d.name.trim().length > 50) e.name = 'Bot name must be under 50 characters.';
    if (!d.greeting || d.greeting.trim().length < 10) e.greeting = 'Greeting must be at least 10 characters.';
    else if (d.greeting.trim().length > 300) e.greeting = 'Greeting must be under 300 characters.';
    return e;
  }

  function save() {
    const e = validate(draft);
    setErrors(e);
    if (Object.keys(e).length) return;
    setStatus('saving');
    mockSave(mockErrorOn)
      .then(() => {
        updateBot({ name: draft.name, greeting: draft.greeting });
        setStatus('idle');
        notify('success', 'Bot details saved');
      })
      .catch(() => {
        setStatus('error');
      });
  }

  return (
    <div>
      <div className="panel-header">
        <h1>Bot name &amp; greeting</h1>
        <p>This is the first thing a visitor sees — pick a name and an opening message that matches your brand.</p>
      </div>
      {status === 'error' && <AlertBanner text="We couldn't save your changes. Try again." onRetry={save} />}
      <div className="card">
        {isEmpty && (
          <div className="empty-state">
            <div className="empty-icon"><Icon.bot s={22} /></div>
            <h3>Give your bot a name and a first message</h3>
            <p>Visitors will see this name and greeting the moment they open the chat widget.</p>
          </div>
        )}

        <div className={'field' + (errors.name ? ' invalid' : '')}>
          <label htmlFor="bot-name">Bot name</label>
          <input
            id="bot-name"
            type="text"
            placeholder="e.g. ChatBizz Assistant"
            value={draft.name}
            onChange={(e) => setDraft({ ...draft, name: e.target.value })}
            maxLength={60}
          />
          {errors.name && <div className="error-text"><Icon.alert s={12} /> {errors.name}</div>}
        </div>

        <div className={'field' + (errors.greeting ? ' invalid' : '')}>
          <label htmlFor="bot-greeting">
            Greeting message
            <span className={'counter' + (draft.greeting.length > 300 ? ' danger' : '')}>
              {draft.greeting.length} / 300
            </span>
          </label>
          <textarea
            id="bot-greeting"
            placeholder="e.g. Hi! Welcome to ChatBizz AI 👋 How can I help you today?"
            value={draft.greeting}
            onChange={(e) => setDraft({ ...draft, greeting: e.target.value })}
            rows={3}
          />
          {errors.greeting && <div className="error-text"><Icon.alert s={12} /> {errors.greeting}</div>}
        </div>

        {draft.greeting && (
          <div className="field">
            <div className="preview-label">Preview</div>
            <div className="bubble">{draft.greeting}</div>
          </div>
        )}

        <div className="actions-row">
          <button className="btn-primary" disabled={status === 'saving'} onClick={save}>
            {status === 'saving' && <span className="spinner"></span>}
            {status === 'saving' ? 'Saving…' : 'Save changes'}
          </button>
        </div>
      </div>
    </div>
  );
}
